import { style } from "@vanilla-extract/css";

/**
 * Fixed, not fluid: the trigger sits in a control bar, and one that grows
 * with the value it holds shifts every neighbour on selection. It
 * ellipsises what doesn't fit.
 */
export const viewSelectorSlot = style({
  display: "flex",
  flex: "0 0 auto",
  // Wide enough to read a view's name next to the eyebrow, and the popover
  // inherits it (``--radix-popover-trigger-width``) so the summary line under
  // each row survives too. Capped as a share of the bar so a narrow laptop
  // squeezes this rather than overflowing the row — a viewport-driven cap,
  // not a value-driven one, so nothing moves when a view is picked.
  width: "21rem",
  maxWidth: "45%",
  minWidth: 0
});
